import { Typography, Grid, Box } from "@mui/material";
import { useAuth } from "hooks/useAuth";
import { useMemo, useState } from "react";

const ReceiptHeader = ({
  label = "ใบเสร็จรับเงิน",
  data,
  date = [],
  contracts = [],
}) => {
  const { user } = useAuth();

  const dataDate = useMemo(
    () => [
      {
        label: "วันที่ทำรายการ",
        value: new Date().toLocaleDateString("th-TH", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
      },
      ...(date || []),
    ],
    [date]
  );

  return (
    <Grid container mb={1}>
      <Grid container alignItems="center">
        {/* Left Section */}
        <Grid item xs={8}>
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <img
                src={user?.company_logo}
                alt="รูปภาพโรงรับจำนำ"
                style={{ height: "50px", width: "50px" }}
              />
            </Grid>
            <Grid item xs={10}>
              <Typography fontWeight="bold">{user?.company_name}</Typography>
              <Typography>
                {[user?.alley, user?.road, user?.company_address, user?.zipcode]
                  .filter(Boolean)
                  .join(" ")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Section */}
        <Grid item xs={4} textAlign="left">
          <Box
            style={{
              backgroundColor: "rgba(0, 187, 159, 20%)", // Opacity for the background only
              padding: "8px",
              textAlign: "center",
              border: "solid 1px #00BB9F", // Border remains fully opaque
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <Typography variant="h6" style={{ color: "#00BB9F" }}>
              {label ?? "ใบเสร็จรับเงิน"}
            </Typography>
            <Typography>เลขที่ XXXXXXXXXXXXX</Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={1}>
        {/* Left Section */}
        <Grid item xs={8}>
          <Grid container alignItems="center">
            <Grid container mt={1}>
              <Grid item xs={3}>
                <Typography
                  style={{
                    color: "#00BB9F",
                    fontWeight: "bold",
                  }}
                >
                  ชื่อ-นามสกุล:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography style={{ fontWeight: 500 }}>
                  {data?.fullName || ""}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  style={{
                    color: "#00BB9F",
                    fontWeight: "bold",
                  }}
                >
                  ที่อยู่:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontWeight: 500,
                    wordBreak: "break-word", // บังคับตัดคำถ้ายาว
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {data?.address || ""}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  style={{
                    color: "#00BB9F",
                    fontWeight: "bold",
                  }}
                >
                  เบอร์โทรศัพท์:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography style={{ fontWeight: 500 }}>
                  {data?.phoneNumber || ""}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  style={{
                    color: "#00BB9F",
                    fontWeight: "bold",
                  }}
                >
                  เลขบัตรประชาชน:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography style={{ fontWeight: 500 }}>
                  {data?.idCardNumber || ""}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Section */}
        <Grid item xs={4} textAlign="left">
          <Box>
            {dataDate.map((day, dIndex) => {
              return (
                <Grid container item key={dIndex}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                      }}
                    >
                      {day.label}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography style={{ fontWeight: 500 }}>
                      {isNaN(day?.value) ? day?.value : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
            {contracts &&
              contracts.map((cont, cIndex) => (
                <Grid container item key={cIndex}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        color: "#00BB9F",
                        fontWeight: "bold",
                      }}
                    >
                      {cont.label}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography style={{ fontWeight: 500 }}>
                      {isNaN(cont?.value) ? cont?.value : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReceiptHeader;
